module.exports = __webpack_public_path__ + "static/media/04(1).8e5f3ce9.jpg";